export const leadership = [
  ['justas-milda', 'founders'],
  ['thomasp', 'ceo'],
  ['adam', 'coo'],
]
